// 1-10 and 25 years in months
export const MORTGAGE_TERMS_ALL = 'all';
export const MORTGAGE_TERMS = [ 12, 24, 36, 48, 60, 72, 84, 96, 108, 120, 300 ];